import React from 'react'
import styled from 'styled-components'

type Props = {
  children: React.ReactNode
}

export const SubTitle: React.FC<Props> = props => (
  <StyledSubTitle>{props.children}</StyledSubTitle>
)

const StyledSubTitle = styled.div`
  margin-top: 16px;
  text-align: center;
  font-size: 14px;
  font-weight: 300;
  line-height: 14px;
  word-wrap: break-word;
`
